import { IStorageHandler } from "../storage-handler.interface";
import { NativeStorage } from "@ionic-native/native-storage";
import { StorageHandler } from "./storage-handler";
import { isDefined, isString } from "ionic-angular/util/util";

export class NativeStorageHandler extends StorageHandler implements IStorageHandler {
    constructor(public readonly key: string, public readonly storage: NativeStorage) {
        super("Native", key);
    }
 
    protected mapKey(key): string {
        return `${this.key}-${key}`;
    }

    protected unmapKey(key): string {
        return key.substring(this.key.length + 1);
    }

    protected validateValue(value: any): any {
        // tslint:disable-next-line:no-null-keyword
        return isDefined(value) ? value : null;
    }

    setItem(key: string, value: any): Promise<any> {
        this.logger(`Set item for key: ${key} - value:`, this.validateValue(value));
        
        return this.storage
                    .setItem(this.mapKey(key), this.validateValue(value))
                    .catch(reason => this.loggerError(`Set Item Error for key ${key}:`, reason));
    }

    getItem(key: string): Promise<any> {
        this.logger(`Get item for key:`, key);
        return this.storage
                    .getItem(this.mapKey(key))
                    .catch(reason => this.loggerError(`Get Item Error for key ${key}:`, reason));
    }

    removeItem(key: string): Promise<any> {
        this.logger(`Remove item for key:`, key);
        return this.storage
                    .remove(this.mapKey(key))
                    .catch(reason => this.loggerError(`Remove Item Error for key ${key}:`, reason));
    }

    clear(): Promise<any> {
        this.logger(`Clear`);
        return this.clearValuesForType()
                    .catch(reason => this.loggerError(`Clear Error:`, reason));
    }

    keys(): Promise<Array<string>> {
        return new Promise((resolve, reject) => {
            this.storage.keys().then(
                keys => {
                    keys = keys.filter(key => {
                        return isString(key) && key.startsWith(this.key);
                    }).map(key => this.unmapKey(key));
                    resolve(keys);
                },
                reject
            ).catch(reason => this.loggerError(`Keys Error:`, reason));
        });
    }

    length(): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            this.keys().then(keys => {
                    this.logger(`Length resolve:`, keys.length);

                    resolve(keys.length);
                },
                reject
            );
        });
    }

    forEach(iteratorCallback: (value: any, key: string, iterationNumber: Number) => any): Promise<null> {

        const items: Array<{ item: any, key: string }> = [];

        return new Promise((resolve, reject) => {

            this.keys().then(
                keys => {
                    // map each key to a promise that will retrieve the item and add it to the items array
                    const p = keys.map(key => new Promise((_resolve, _reject) => {
                        this.getItem(key).then(
                            item => {
                                items.push({key, item});
                                _resolve();
                            },
                            _reject
                        );
                    }));

                    // wait for all promises to resolve, then run the iteratorCallback over each item
                    Promise.all(p).then(
                        () => {
                            items.forEach((item, index) => {
                                iteratorCallback(item.item, item.key, index);
                            });

                            resolve(undefined);
                        },
                        reject
                    );
                },
                reject
            );
        });
    }

    private clearValuesForType(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.keys().then(
                keys => {
                    const p = keys.map(key => new Promise((_resolve, _reject) => {
                            this.removeItem(key).then(
                                _resolve,
                                _reject
                            );
                        })
                    );

                    Promise.all(p).then(
                        resolve,
                        reject
                    );
                },
                reject
            );
        });
    }
}



// WEBPACK FOOTER //
// ./src/core/services/storage/handlers/native-storage-handler.ts